import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@/components';
import {
  seedPrerequisiteEntitiesAsync,
  clearCacheOfAspynPushesAsync,
} from '../redux';
import {
  seedPrerequisiteEntitiesLoadingSelector,
  clearCacheOfAspynPushesLoadingSelector,
} from '@/redux/loading';

const Settings = () => {
  const dispatch = useDispatch();
  const isSeedingLoading = useSelector(seedPrerequisiteEntitiesLoadingSelector);
  const isCacheClearingLoading = useSelector(clearCacheOfAspynPushesLoadingSelector);

  const handleRunSeeders = useCallback(() => {
    dispatch(seedPrerequisiteEntitiesAsync.request());
  }, [dispatch]);

  const handleClearCache = useCallback(() => {
    dispatch(clearCacheOfAspynPushesAsync.request());
  }, [dispatch]);

  return (
    <div className="flex flex-col w-full h-full p-8">
      <div className="mb-10">
        <h1 className="text-4xl whitespace-nowrap text-gray-900">Settings</h1>
      </div>

      <div className="grow space-y-6">
        {/* Run Seeders Section */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-3">Run Seeders</h3>
          <p className="text-sm text-gray-600 mb-4">
            Execute database seeders to populate prerequisite data in Aspyn.
          </p>
          <Button
            onClick={handleRunSeeders}
            disabled={isSeedingLoading}
            color="blue"
          >
            {isSeedingLoading ? 'Seeding...' : 'Run Seeders'}
          </Button>
        </div>

        {/* Clear Cache Section */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-3">Clear Cache</h3>
          <p className="text-sm text-gray-600 mb-4">
            Clear the cached results of previous pushes to execute a fresh push next time.
          </p>
          <Button
            onClick={handleClearCache}
            disabled={isCacheClearingLoading}
            color="blue"
          >
            {isCacheClearingLoading ? 'Cache Clearing...' : 'Clear Cache'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
